var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartdonut chartdonut_animation",class:_vm.sizeClass},[_c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('g',[_c('circle',{attrs:{"cx":"50%","cy":"50%","r":_vm.radius,"stroke-width":"3","stroke":"#02DCAA","fill":"none","stroke-dasharray":_vm.dashArray}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }